import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
declare var window;
if (environment.production) {
  enableProdMode();
}
var console = (function (oldCons) {
  return {
    log: function (message) {
      if (!environment.production || sessionStorage["debuglog"])
        oldCons.log.apply(null, arguments);

    },
    info: function (message) {
      if (!environment.production || sessionStorage["debuglog"])
        oldCons.info.apply(null, arguments);
    },
    warn: function (message) {
      if (!environment.production || sessionStorage["debuglog"])
        oldCons.warn.apply(null, arguments);
    },
    error: function (message) {
      if (!environment.production || sessionStorage["debuglog"])
        oldCons.error.apply(null, arguments);
    }
  };
}(window.console));
window.console = console;

setTimeout(() => {
  var exceptionLog = (function (onerror) {
    return function () {
      if (!environment.production || sessionStorage["debuglog"]) onerror.apply(null, arguments);
    }
  })(window.onerror);
  window.onerror = exceptionLog;
}, 2000);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
